import { FronteggContext } from '@frontegg/rest-api';
import { Axios } from 'src/lib';
import {
  listAgentsConfig,
  getAgentConfig,
  createAgentConfig,
  updateAgentConfig,
  deleteAgentConfig,
  listRetellAgentsConfig,
} from '../lib/agent.url';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import {
  agentsListSlice,
  agentsItemSlice,
  agentsLoadingSlice,
  retellAgentsListSlice,
} from '../slices/agents.slice';
import { axiosAiva } from 'src/lib/axios';

export const listAgentsAction = (org_uuid, filters = {}) => {
  return async (dispatch) => {
    dispatch(agentsLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      console.log('filters', filters);
      const params = {
        ...filters,
      };
      const { url } = listAgentsConfig();
      const result = await axiosAiva.get(url, { headers, params });
      if (result?.status === 200) {
        dispatch(agentsListSlice(result?.data));
      }
    } catch (e) {
      showToastError('Failed to load agents');
    } finally {
      dispatch(agentsLoadingSlice(false));
    }
  };
};

export const getAgentAction = (org_uuid, agentId) => {
  return async (dispatch) => {
    dispatch(agentsLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = getAgentConfig(agentId);
      const result = await axiosAiva.get(url, { headers });
      if (result?.status === 200) {
        dispatch(agentsItemSlice(result?.data));
      }
    } catch (e) {
      showToastError('Failed to load agent details');
    } finally {
      dispatch(agentsLoadingSlice(false));
    }
  };
};

export const updateAgentAction = (
  org_uuid,
  agentId,
  payload,
  successCallback
) => {
  return async (dispatch) => {
    dispatch(agentsLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = updateAgentConfig(agentId);
      const result = await axiosAiva.put(url, payload, { headers });
      if (result?.status === 200) {
        dispatch(agentsItemSlice(result?.data));
        showToastSuccess('Agent updated successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to update agent');
    } finally {
      dispatch(agentsLoadingSlice(false));
    }
  };
};

export const createAgentAction = (org_uuid, payload, successCallback) => {
  return async (dispatch) => {
    dispatch(agentsLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = createAgentConfig();
      const result = await axiosAiva.post(url, payload, { headers });
      if (result?.status === 201) {
        showToastSuccess('Agent created successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to create agent');
    } finally {
      dispatch(agentsLoadingSlice(false));
    }
  };
};

export const deleteAgentAction = (org_uuid, agentId, successCallback) => {
  return async (dispatch) => {
    dispatch(agentsLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Impersonate-Org-UUID': `${org_uuid}`,
        'Headless-Mode': true,
      };
      const { url } = deleteAgentConfig(agentId);
      const result = await axiosAiva.delete(url, { headers });
      if (result?.status === 200) {
        showToastSuccess('Agent deleted successfully');
        successCallback?.();
      }
    } catch (e) {
      showToastError('Failed to delete agent');
    } finally {
      dispatch(agentsLoadingSlice(false));
    }
  };
};

export const listRetellAgentsAction = () => {
  return async (dispatch) => {
    dispatch(agentsLoadingSlice(true));
    try {
      const token = FronteggContext.getAccessToken();
      const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Headless-Mode': true,
      };
      const { url } = listRetellAgentsConfig();
      const result = await axiosAiva.get(url, { headers });
      if (result?.status === 200) {
        dispatch(retellAgentsListSlice(result?.data?.agents || []));
      }
    } catch (e) {
      showToastError('Failed to load Retell agents');
    } finally {
      dispatch(agentsLoadingSlice(false));
    }
  };
};
